export enum FeatureToggle {
  rtIppCaperBillingEnabled = 'rt_ipp_caper_billing_enabled',
  // Gates retailer-facing access to the Enterprise Status Page. Kept OFF in
  // prod until release so the nav item + route stay hidden there; enabled in
  // dev/staging for testing. Once launched, retailers are opted in by default
  // (the eventual intent is partner-type-only gating).
  rtEnterpriseStatusPageRetailer = 'rt_enterprise_status_page_retailer',
}
